import { Button, Card, CardBody } from "react-bootstrap";


export function ApplicantResultSummary({ applicant = {} }) {
  return (
    <Card>
      <div className="p-2 ps-3 bg-light">
        <div className='row'>
          <div className='col'>
            <div className="p-1">
              <span className="fw-semibold">{applicant?.name}</span>
              {applicant?.primary && <span className="ms-1">(primary)</span>}
            </div>
          </div>
          <div className="col d-flex justify-content-end">
            <Button
              className='border-0'
              variant="outline-primary"
              size="sm"
            >
              View Report
            </Button>
          </div>
        </div>

      </div>
      <CardBody className="py-1 px-0">
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <i className='bi bi-check-circle-fill text-success me-2' />
            <span className='fw-semibold'>Identity</span>
          </li>
          <li className="list-group-item">
            <div>
              <i className='bi bi-exclamation-triangle-fill text-warning me-2' />
              <span className='fw-semibold'>Credit</span>
              <span className='ms-2 badge bg-warning  float-end'>Conditional</span>
            </div>
            <div className="pt-2 ps-2">
              <div>
                <i className='bi bi-chevron-right me-2' />
                <span>Credit score is greater than 500  but less that 550</span>
                <div className="pt-2 ps-2">
                  <i className='bi bi-chevron-double-right me-2' />
                  <span className='fw-semibold'>1 month deposit required.</span>
                </div>
              </div>
            </div>
          </li>
          <li className="list-group-item">
            <i className='bi bi-check-circle-fill text-success me-2' />
            <span className='fw-semibold'>Criminal</span>
            {/* <span className='ms-2 badge bg-success float-end'>Pass</span> */}
          </li>
          <li className="list-group-item">
            <i className='bi bi-check-circle-fill text-success me-2' />
            <span className='fw-semibold'>Income</span>
            {/* <span className='ms-2 badge bg-success float-end'>Pass</span> */}
          </li>
          <li className="list-group-item">
            <i className='bi bi-check-circle-fill text-success me-2' />
            <span className='fw-semibold'>Employment</span>
            {/* <span className='ms-2 badge bg-success float-end'>Pass</span> */}
          </li>
          <li className="list-group-item">
            <i className='bi bi-x-circle-fill text-danger me-2' />
            <span className='fw-semibold'>Rental History</span>
            <span className='ms-2 badge bg-danger float-end'>Decline</span>
            <div className="pt-2 ps-2">
              <div>
                <i className='bi bi-chevron-right me-2' />
                <span>Pending eviction</span>
                {/* <div className="pt-2 ps-2">
                  <i className='bi bi-chevron-double-right me-2' />
                  <span className='fw-semibold'>1 month deposit required.</span>
                </div> */}
              </div>
            </div>
          </li>
        </ul>
      </CardBody>
    </Card>
  )
}
